import { AUTH_PROVIDERS } from '@packages/utils/enums'
import { sdk } from '@lib/sdk/sdk'
import type { TAvailableLoginMethod } from '@packages/utils/types'
import { clientPublicStore } from '@packages/stores'
import { get } from 'svelte/store'

export const getAuthMethodsConfigs = (availableMethods: string[]) => {
  const isEvmCustomProvider = sdk.evm.isEvmProvider()
  return {
    oauth: {
      provider: AUTH_PROVIDERS.OAUTH,
      text: 'credenza auth',
      condition: availableMethods.some((method) => method !== 'evm'),
    },
    evm: {
      provider: AUTH_PROVIDERS.EVM,
      text: 'EVM',
      condition: availableMethods.includes('evm') && isEvmCustomProvider,
    },
  }
}

export const getAvailableLoginMethods = (): TAvailableLoginMethod[] => {
  const methodConfigs = getAuthMethodsConfigs(get(clientPublicStore).available_login_types)
  const availableLoginMethods = Object.entries(methodConfigs)
    .filter(([_, config]) => (config.condition !== undefined ? config.condition : true))
    .map(([_, config]) => ({
      ...config,
    }))

  return availableLoginMethods
}
